(() => {
  const initializeAnnouncementAutoplay = (scope = document) => {
    scope.querySelectorAll('slideshow-component.announcement-bar').forEach((component) => {
      if (component.dataset.autoplayResumeInitialized === 'true') return;

      const slider = component.querySelector('[data-autoplay]');
      const arrowButtons = component.querySelectorAll('button[name="previous"], button[name="next"]');
      const nextButton = component.querySelector('button[name="next"]');

      if (!slider || !nextButton || arrowButtons.length === 0) return;

      component.dataset.autoplayResumeInitialized = 'true';

      const scheduleNextAnnouncement = () => {
        clearTimeout(component.announcementAutoplayResumeTimeout);

        if (slider.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const autoplaySpeed = Number.parseFloat(slider.dataset.speed) * 1000;
        if (!Number.isFinite(autoplaySpeed) || autoplaySpeed <= 0) return;

        component.announcementAutoplayResumeTimeout = window.setTimeout(() => {
          nextButton.click();
        }, autoplaySpeed);
      };

      arrowButtons.forEach((button) => {
        button.addEventListener('click', scheduleNextAnnouncement);
      });
    });
  };

  const initialize = () => initializeAnnouncementAutoplay();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAnnouncementAutoplay(event.target);
  });
})();
